import { Box, Typography } from "@mui/material";

const ChatNoMessages = () => {
  const styles = {
    wrapper: {
      display: "block",
      position: "absolute",
      width: "100%",
      left: "50%",
      top: "50%",
      textAlign: "center",
      transform: "translate(-50%, -50%)",
    },
  };

  return (
    <Box sx={styles.wrapper}>
      <Typography variant="h1">chat vazio</Typography>
      <Typography variant="subtitle1">
        ainda não houve nenhuma interação com o chat
      </Typography>
    </Box>
  );
};

export default ChatNoMessages;
